import React from 'react';
import PropTypes from 'prop-types';

import './modal.style.css';

const Modal = props => {
    if (!props.show) return null;
    return (
        <div className="ErrorModalWrapper">
            <div>
                <span className="ErrorModalCloseButton" onClick={props.onClose}>&times;</span>
                {props.children}
                <button className='ErrorModalOkButton' onClick={props.onClose}>
                    Ok
                </button>
            </div>
        </div>
    );
};

Modal.propTypes = {
    show: PropTypes.bool,
    children: PropTypes.node,
    onClose: PropTypes.func,
};

export default Modal;
